<template>
  <div class="page-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <!-- 表格 -->
        <div>
          <div class="btn" @click="handleModal('add')">+ 新增字典项</div>
        </div>
        <el-table
          :data="list"
          class="order-table table no-border-table"
          ref="orderTable"
          border
          highlight-current-row
          :header-cell-style="{
            color: '#333',
            background: '#FAFAFA',
            borderBottom: '1px solid #E8E8E8',
            height: '44px',
          }"
          :row-style="{
            height: '44px',
          }"
        >
          <el-table-column
            prop="created"
            align="center"
            label="日期"
          ></el-table-column>
          <el-table-column
            prop="labelName"
            align="center"
            label="展示值"
          ></el-table-column>
          <el-table-column
            prop="value"
            align="center"
            label="字典值"
          ></el-table-column>
          <el-table-column prop="detailOpen" align="center" label="启用状态">
            <div slot-scope="scope">
              {{ openMap[scope.row.detailOpen] }}
            </div>
          </el-table-column>
          <el-table-column
            prop="detailSort"
            align="center"
            label="排序标记"
          ></el-table-column>
          <el-table-column prop="detailLock" align="center" label="控制锁">
            <div slot-scope="scope">
              {{ lockMap[scope.row.detailLock] }}
            </div>
          </el-table-column>
          <el-table-column label="操作" align="center" width="300">
            <div slot-scope="scope" class="table-btn-box">
              <button
                size="mini"
                class="table-btn"
                @click="handleModal('edit', scope.row)"
              >
                变更
              </button>
              <button
                size="mini"
                class="table-btn"
                @click="handleDelete(scope.row.id)"
              >
                删除
              </button>
              <button
                size="mini"
                v-if="scope.row.detailLock === 1"
                class="table-btn"
                @click="handleLock(scope.row.id)"
              >
                控制锁
              </button>
            </div>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog :visible.sync="visible" class="dialog" width="560px" top="25vh">
      <div slot="title" class="dialog-title">
        {{ (type === "add" ? "新增" : "变更") + "字典项" }}
      </div>
      <el-form ref="form" :model="form" class="form" label-width="auto">
        <el-form-item label="展示值：" prop="labelName" class="form-item">
          <el-input
            size="small"
            placeholder="请输入展示值"
            v-model="form.labelName"
          ></el-input>
        </el-form-item>
        <el-form-item label="字典值：" prop="value" class="form-item">
          <el-input
            size="small"
            placeholder="请输入字典值"
            v-model="form.value"
          ></el-input>
        </el-form-item>
        <el-form-item label="启用状态：" prop="detailOpen" class="form-item">
          <el-switch
            v-model="form.detailOpen"
            :active-value="1"
            :inactive-value="2"
            active-color="#13ce66"
          >
          </el-switch>
        </el-form-item>
        <el-form-item label="排序标记：" prop="detailSort" class="form-item">
          <el-input-number
            v-model="form.detailSort"
            label="排序标记"
            :step="1"
            step-strictly
            style="width: 140px;"
            size="small"
            placeholder="排序标记"
          ></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancel-btn btn" @click="visible = false"
          >取 消</el-button
        >
        <el-button class="confirm-btn btn" @click="handleConfirm"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import Header from '../../components/common/header';
export default {
  components: {
    Header
  },
  name: 'banner',
  data() {
    return {
      loading: 0, // 加载中
      title: {
        // 页面标题
        firstTitile: '商城设置',
        secondTitle: '字典设置'
      },
      openMap: {
        1: '是',
        2: '否'
      },
      lockMap: {
        1: '未开启',
        2: '已开启，该项不能随意修改',
      },
      list: [],
      total: 0,
      type: '',
      visible: false,
      form: {
        labelName: '',
        value: '',
        detailSort: null,
        detailOpen: 1
      },
      id: null
    };
  },
  mounted() {
    // 获取列表
    this.getList();
  },
  computed: {},
  methods: {
    // 获取轮播列表
    getList() {
      this.loading++;
      this.httpGet(this.$root.getDictionaryItem, {
        id: this.$route.query.id
      }).then(
        (res) => {
          this.loading--;
          this.list = res;
          this.total = res.total;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    // 编辑轮播弹窗
    handleModal(type, rowData) {
      this.type = type;
      if (type === 'edit') {
        this.id = rowData.id;
        this.form = {
          labelName: rowData.labelName,
          value: rowData.value,
          detailSort: rowData.detailSort,
          detailOpen: rowData.detailOpen
        };
      } else {
        this.form = {
          labelName: '',
          value: '',
          detailSort: '',
          detailOpen: 1
        };
        this.$refs.form && this.$refs.form.clearValidate();
      }
      this.visible = true;
    },
    // 删除轮播图
    handleDelete(id) {
      this.$confirm(
        `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>确定要删除该字典项吗?</p>`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancel-btn',
          confirmButtonClass: 'confirm-btn',
          customClass: 'confirm-box',
          dangerouslyUseHTMLString: true,
          showClose: false,
          type: 'none'
        }
      ).then(() => {
        this.loading++;
        this.httpDelete(this.$root.deleteDictionaryItem, {
          id
        }).then(
          (res) => {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.loading--;
            this.getList();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      });
    },
    handleLock(id) {
      this.$confirm(
        `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>确认后,该项数据不能更改,且操作不可逆, 确认锁定吗?</p>`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancel-btn',
          confirmButtonClass: 'confirm-btn',
          customClass: 'confirm-box',
          dangerouslyUseHTMLString: true,
          showClose: false,
          type: 'none'
        }
      ).then(() => {
        this.loading++;
        this.httpPut(this.$root.lockDictionaryItem, {
          id
        }).then(
          (res) => {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.loading--;
            this.getList();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      });
    },
    // 轮播
    handleConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let url =
            this.type === 'add'
              ? this.$root.addDictionaryItem
              : this.$root.updateDictionaryItem;
          let method = this.type === 'add' ? 'httpPost' : 'httpPut';
          let inputData =
            this.type === 'add'
              ? {
                  ...this.form,
                  fid: +this.$route.query.id
                }
              : {
                  ...this.form,
                  id: this.id
                };
          this.loading++;
          this[method](url, inputData).then(
            (res) => {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.loading--;
              this.visible = false;
              this.getList();
            },
            (res) => {
              this.loading--;
              this.$message.error(res);
            }
          );
        }
      });
    }
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.page-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    // content 表格
    .content {
      // 按钮
      .btn {
        // width: 100px;
        display: inline-block;
        padding: 0 10px;
        height: 32px;
        line-height: 32px;
        confirm-btn();
        font-size: 14px;
        margin-bottom: 16px;
        // margin: 16px 0;
      }

      .tip {
        margin-left: 32px;
        color: #999;
      }

      .table-img {
        height: 70px;
        width: auto;
      }
    }
  }

  .dialog-content {
    flex-y();
  }

  .form {
    padding: 12px 24px;

    .sort-tip {
      word(14px, #c8c8c8);
      line-height: 20px;
    }
  }
}
</style>
